module.exports = __webpack_public_path__ + "static/salon-de-pasajeros---iluminacion-e608f19e04b85cce66bd1ec24ba8b6fb.jpg";